"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_STYLE = exports.MAX_ARROWS = exports.DEFAULT_ARROWS = exports.ArrowStyles = void 0; // Describes the arrow style of polylines

var ArrowStyles = {
  NONE: 0,
  FORWARD: 1,
  BACKWARD: 2,
  BOTH: 3
};
exports.ArrowStyles = ArrowStyles;
var DEFAULT_ARROWS = 1;
exports.DEFAULT_ARROWS = DEFAULT_ARROWS;
var MAX_ARROWS = 3;
exports.MAX_ARROWS = MAX_ARROWS;
var DEFAULT_STYLE = {
  arrowColor: [0, 0, 0, 1],
  arrowCount: DEFAULT_ARROWS,
  arrowStyle: ArrowStyles.NONE,
  fillColor: [0, 0, 0, 1],
  lineColor: [0, 0, 0, 1],
  lineWidthMeters: 5,
  outlineRadiusMeters: 0,
  opacity: 1,
  zLevel: 0
};
exports.DEFAULT_STYLE = DEFAULT_STYLE;